module.exports = __webpack_public_path__ + "static/media/empty-history.a162b67c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/statsradio/assets/img/empty-history.svg
// module id = ./src/statsradio/assets/img/empty-history.svg
// module chunks = 18